/* @flow */
import React from 'react';
import { Row, Column } from 'components/UIKit/Flex';

type HeaderProps = {
  children: any,
  style: Object,
  CloseLink(props: Object): React.Element,
  CloseIcon(props: Object): React.Element,
}

let baseStyle = {
  fontSize: '1.2rem',
  padding: '1.1rem',
  alignItems: 'center',
  textTransform: 'capitalize'
};

export default function TransactionsDetailsHeader({
  children, style, CloseIcon, CloseLink
}: HeaderProps): React.Element {
  return (
    <Row style={{...baseStyle, ...style}}>
      <Column>
        {children.length > 30 ? `${children.substr(0, 30)}...` : children }
      </Column>
      <Row style={{marginLeft: 'auto'}}>

        {CloseLink && <CloseLink><CloseIcon /></CloseLink>}
      </Row>
    </Row>
  );
}
